// Fire-and-forget funnel analytics for the upload flow.
//
// Design rules:
//  - It must NEVER throw or block the UI. Every call is wrapped and swallows
//    errors; the request is not awaited.
//  - It only sends an event name + coarse, non-identifying metadata (page
//    count, file kind, number of services, an error category). No bill
//    contents, prices, hospital names, or personal info.
//  - A `flowId` ties one upload attempt's steps together so we can measure
//    drop-off between steps. It lives in sessionStorage so it survives a
//    reload within the same tab and is shared across the step components.
//
// The owned server-side funnel is always the primary sink. When
// PLAUSIBLE_FUNNEL_EVENTS is on, the same events are also forwarded to
// Plausible as custom events (see featureFlags.js).

import { PLAUSIBLE_FUNNEL_EVENTS } from './featureFlags';

const FLOW_KEY = 'vetbill_flow_id';

// Start a new upload attempt and return its id. Call this when the user first
// adds a file on step 1.
export function startFlow() {
    const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    try {
        sessionStorage.setItem(FLOW_KEY, id);
    } catch (e) {
        /* sessionStorage unavailable — analytics degrade silently */
    }
    return id;
}

export function getFlowId() {
    try {
        return sessionStorage.getItem(FLOW_KEY) || null;
    } catch (e) {
        return null;
    }
}

export function track(event, meta = {}) {
    // Primary: our owned server-side funnel.
    try {
        fetch('/api/events', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token') || ''}`
            },
            body: JSON.stringify({ event, flowId: getFlowId(), meta })
        }).catch(() => {});
    } catch (e) {
        /* analytics must never break the app */
    }

    // Optional: also forward to Plausible as a custom event when enabled.
    if (PLAUSIBLE_FUNNEL_EVENTS) {
        try {
            if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
                window.plausible(event, { props: meta });
            }
        } catch (e) {
            /* analytics must never break the app */
        }
    }
}
